import { type Asset, type Wallet, ModelView } from '@/types';

export class WalletModel extends ModelView<Wallet> {
    constructor(item: Wallet) {
        super(item);
    }

    get blockchain() {
        return this.item.blockchain;
    }

    get blockchainName() {
        return this.item.blockchainName;
    }

    get assetId() {
        return this.item.assetId;
    }

    get balance() {
        return this.item.balance;
    }

    get isEmpty() {
        return Number(this.balance.amount) === 0;
    }

    get addresses() {
        return this.item.addresses;
    }

    get name() {
        return this.item.name;
    }
}

export class AssetModel extends ModelView<Asset> {
    constructor(item: Asset) {
        super(item);
    }

    get code() {
        return this.item.code;
    }

    get currency() {
        return this.item.currency;
    }

    get name() {
        return this.item.name;
    }

    get blockchain() {
        return this.item.blockchain;
    }

    get network() {
        return this.item.network;
    }

    get decimals() {
        return this.item.decimals;
    }

    get tagNeeded() {
        return this.item.tagNeeded;
    }
}
